import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../core/i18n'
import { postService } from '../../core/services'
import * as constants from '../../static/constants'
import * as interfaces from '../../static/interfaces'
import { Button, InputText } from '../atoms'

declare var window: interfaces.IWindow

const FIELDS = {
  amount: 'amount',
}

interface IErrors {
  [key: string]: string | null
}

interface IProps {
  post: any
  agent_ranks: any
}

export const PostGuideRankFee: React.FC<IProps> = props => {
  const [isSubmitEnabled, setIsSubmitEnabled] = React.useState(true)
  const [errors, setErrors] = React.useState<IErrors>({})
  const [postRankFees, setPostRankFees] = React.useState(props.post.post_rank_fees)

  const handleSubmit = async () => {
    const { flush } = await postService.updatePostGuideRankFees(props.post.id, {
      post: { post_rank_fees_attributes: postRankFees },
    })
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    // 公開ボタンの状態と未設定表示を最新化する(Costタブと同様)
    if (flush.type === 'success') {
      window.location.reload()
    }
  }

  const onChange = event => {
    const agent_rank_id = Number(event.target.name)
    const amount = event.target.value
    const existing = postRankFees.find(postRankFee => postRankFee.agent_rank_id === agent_rank_id)
    const params = { ...existing, agent_rank_id, amount }
    setPostRankFees(
      postRankFees.filter(postRankFee => postRankFee.agent_rank_id !== agent_rank_id).concat(params)
    )
  }

  return (
    <Wrapper>
      <h2 className="Editor_Title">{I18n.t('post.input_guide_fee')}</h2>
      {props.agent_ranks.length > 0 ? (
        <form className="FormItmes">
          <ul>
            {props.agent_ranks.map((agent_rank, index) => (
              <FormItem key={agent_rank.id} className={agent_rank.is_base ? '_base' : undefined}>
                <RankLabel>
                  {agent_rank.is_base && (
                    <span className="RankLabel_Kind _base">{I18n.t('agent_rank.base')}</span>
                  )}
                  {agent_rank.rank_kind === 'special' && (
                    <span className="RankLabel_Kind">{I18n.t('agent_rank.kind_special')}</span>
                  )}
                  {agent_rank.name_i18n}
                </RankLabel>
                <InputText
                  required={true}
                  name={agent_rank.id}
                  placeholder={String(10000 * (index + 1))}
                  onChangeHandler={onChange}
                  defaultValue={
                    props.post.post_rank_fees.find(
                      postRankFee => postRankFee.agent_rank_id === agent_rank.id
                    )?.amount
                  }
                  error={errors.private_quantity}
                />
              </FormItem>
            ))}
          </ul>
          <div className="Editor_Footer">
            <Button
              disabled={!isSubmitEnabled}
              handleClick={handleSubmit}
              textColor={constants.COLORS.white}
              backgroundColor={constants.COLORS.primary}
            >
              {I18n.t('generic.update')}
            </Button>
          </div>
        </form>
      ) : (
        <div className="FormItmes">
          <a href="/agent/agent_ranks">{I18n.t('post.set_rank')}</a>
        </div>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding-bottom: 14px;
  .FormItmes {
    margin: 14px 16px;
  }
`
const FormItem = styled.li`
  display: flex;
  align-items: center;

  & + & {
    margin-top: 16px;
  }

  /* ベースランクは先頭に来るため、その直後の行に罫線を引いてベースと他ランクを区切る */
  &._base + & {
    margin-top: 24px;
    padding-top: 24px;
    border-top: solid 1px ${constants.COLORS.divider};
  }

  .InputText {
    flex: 1;
    min-width: 0;
  }

  .FormItem_Title {
    font-size: 15px;
    font-weight: bold;
  }

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

// InputLabelと同じ幅・体裁を保ちつつ、ベース・特殊ランクにはラベルを添える
const RankLabel = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 180px;
  padding: 8px 12px 8px 0;
  font-size: 14px;
  font-weight: bold;
  word-break: break-word;

  .RankLabel_Kind {
    flex-shrink: 0;
    margin-right: 8px;
    padding: 2px 6px;
    border: solid 1px ${constants.COLORS.subText};
    border-radius: 4px;
    color: ${constants.COLORS.subText};
    font-size: 11px;
    font-weight: 600;

    /* 特殊ラベルと区別できるよう、ベースはプライマリ色で塗る */
    &._base {
      border-color: ${constants.COLORS.primary};
      background-color: ${constants.COLORS.primary};
      color: ${constants.COLORS.white};
    }
  }

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    width: 100%;
    padding-right: 0;
  }
`

export default PostGuideRankFee
